import memoize from 'transmute/memoize';
import { ENROLLMENT } from 'automation-ui-flow-core/canvas/SpecialActionIds';
export const getNodeHeights = memoize(({
  showEnrollmentCard
}) => new Map([[`node-${ENROLLMENT}`, showEnrollmentCard ? 360 : 0]]), ({
  showEnrollmentCard
}) => `${showEnrollmentCard}`);